import * as yup from 'yup'

const schema = yup.object().shape({
  reason: yup.string().required().max(1000),
})

export default schema
